import { render, staticRenderFns } from "./CalculationList.vue?vue&type=template&id=41c4132a&scoped=true"
import script from "./CalculationList.vue?vue&type=script&lang=js"
export * from "./CalculationList.vue?vue&type=script&lang=js"
import style0 from "./CalculationList.vue?vue&type=style&index=0&id=41c4132a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c4132a",
  null
  
)

export default component.exports